import { render, staticRenderFns } from "./UserGuide.vue?vue&type=template&id=4fa4105e&scoped=true"
import script from "./UserGuide.vue?vue&type=script&lang=js"
export * from "./UserGuide.vue?vue&type=script&lang=js"
import style0 from "./UserGuide.vue?vue&type=style&index=0&id=4fa4105e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa4105e",
  null
  
)

export default component.exports